"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionAlliance = require("@/api/distributionAlliance");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DistributionWithdrawReview',
  data: function data() {
    return {
      status: null,
      list: [],
      loading: false,
      saving: false,
      dialogVisible: false,
      dialogTitle: '',
      remark: '',
      current: null,
      action: '',
      plainCards: {}
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    statusText: function statusText(status) {
      return ['待审核', '审核通过', '已打款', '已驳回', '已取消'][status] || '未知';
    },
    roleText: function roleText(role) {
      return role === 'PROMOTER' ? '淘客' : '团长';
    },
    tagType: function tagType(status) {
      return status === 2 ? 'success' : status === 3 ? 'danger' : status === 0 ? 'warning' : '';
    },
    load: function load() {
      var _this = this;
      this.loading = true;
      this.plainCards = {};
      (0, _distributionAlliance.getLeaderWithdrawList)({
        status: this.status,
        accountRole: this.$route.meta.accountRole,
        page: 1,
        size: 100
      }).then(function (res) {
        _this.list = res.data || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 明文按需取：换页或重查后 plainCards 清空，卡号不会一直挂在页面上
    reveal: function reveal(row) {
      var _this2 = this;
      (0, _distributionAlliance.getLeaderWithdrawCard)(row.id).then(function (res) {
        _this2.$set(_this2.plainCards, row.id, res.data && res.data.cardNo || row.accountNo);
      });
    },
    operate: function operate(row, action) {
      this.current = row;
      this.action = action;
      this.remark = '';
      this.dialogTitle = action === 'approve' ? '审核提现' : action === 'reject' ? '驳回提现' : '确认人工打款';
      this.dialogVisible = true;
    },
    confirm: function confirm() {
      var _this3 = this;
      this.saving = true;
      var fn = this.action === 'approve' ? _distributionAlliance.approveLeaderWithdraw : this.action === 'reject' ? _distributionAlliance.rejectLeaderWithdraw : _distributionAlliance.markLeaderWithdrawPaid;
      fn(this.current.id, this.remark).then(function () {
        _this3.$message.success('操作成功');
        _this3.dialogVisible = false;
        _this3.load();
      }).finally(function () {
        _this3.saving = false;
      });
    }
  }
};